// extracted by mini-css-extract-plugin
module.exports = {"weight":"Weight_weight__593X_","weightInputs":"Weight_weightInputs__XGQci"};